import type { SerializedKitAsset } from '../../../../../../redux/api/fymAPI.types';

const WORKING = new Set(['queued', 'planning', 'rendering']);

/** The largest time left of the kit assets that are being made now, or null (design kit-redo-cover c1). Pure. */
export function workingEtaSec(assets: ReadonlyArray<Pick<SerializedKitAsset, 'status' | 'etaSec'>>): number | null {
  let largest: number | null = null;
  for (const asset of assets) {
    const eta = asset.etaSec ?? null;
    if (WORKING.has(asset.status) && eta !== null && (largest === null || eta > largest)) {
      largest = eta;
    }
  }
  return largest;
}
